<mat-card style="margin-top:30px;margin-left:10px;margin-right:30px;width:99%;height:100%;min-height:1000px;">
    <div class="container-fluid">

        @if(showWorkingBanner){
            <div style="margin-top:10px;margin-bottom:10px;">
                <app-processing-banner [WaitMessage]="workingBannerMessage"></app-processing-banner>
            </div>
        }

        @if(showSuccessBanner){
            <div style="margin-top:10px;margin-bottom:10px;">
                <app-success-banner [SuccessMessage]="successBannerMessage"></app-success-banner>
            </div>
        }

        
      

        <!-- @if(showErrorBanner){
            <div style="margin-top:10px;margin-bottom:10px;">
                <app-error-banner [ErrorMessage]="errorBannerMessage"></app-error-banner>
            </div>
        }
       -->
            
        <div class="row" style="margin-top:10px;">
           
        </div>
        <div class="row mt-4" >
            <div class="col-12">
                <strong>New Payment Details</strong>
            </div>
        </div>
        <hr/>
        <div class="row">
            <div class="col-1">
                <button mat-mini-fab color="primary"  style="margin-left:5px;" aria-label="Reset Payment Data" (click)="onResetPaymentData()"  matTooltip="Reset Payment Data">
                    <mat-icon>restart_alt</mat-icon>
                  </button>
                        <!-- <mat-icon style="margin-top:10px;margin-left:15px;color:black" >restart_alt</mat-icon> -->
            </div>
            <div class="col-2">
                <select id="pmtSelectPaymentType"  
                    class="form-select" 
                    aria-label="Default select example" 
                    style="font-size:12px;width:100%;margin-right:5px;margin-top:7px;"
                    (blur)="setPaymentDataValidStatus()" 
                    (change) ="onPaymentChangeForm()" >
                    <option *ngFor="let paymentType of paymentTypes" [value]="paymentType.paymentCode" 
                        [selected]="paymentType.paymentDescription === defaultPaymentType"  >
                        {{paymentType.paymentDescription}}
                        </option>
                  </select>
            </div>
            <div class="col-1">
                <mat-form-field appearance="fill" style="width:100%;font-size:12px;">
                    <mat-label>Amount</mat-label>
                    <input id="pmtAmount"
                    onClick="this.select();"
                        type="number"
                        (blur)="setPaymentDataValidStatus()"
                        (keyup)="setPaymentDataValidStatus()"  
                        matInput placeholder="Amount"
                        [ngStyle]="{'color':isValueNegative() ? 'red': 'black'}"
                        min=".01"
                        (focus)="setPaymentDataValidStatus()" max="999999.99">
                  </mat-form-field>
            </div>
            <div class="col-1">
                <mat-form-field appearance="fill" style="width:100%;font-size:12px;">
                    <mat-label>Ref No.</mat-label>
                    <input id="pmtReferenceNumber"
                        
                        (blur)="setPaymentDataValidStatus()" 
                        (keyup)="onKeyPressedReferenceNumber($event)"
                        matInput [placeholder]="referenceNumberPlaceholderForm"  (focus)="setPaymentDataValidStatus()">
                  </mat-form-field>
            </div>
          
            <div class="col-3">
                <mat-form-field appearance="fill" style="width:100%;font-size:12px;">
                    <mat-label>Expected Deposit Date</mat-label>
                    <input matInput 
                        DateToCurrentYear
                        [matDatepicker]="paymentDepositDate" 
                        [(ngModel)]="paymentFormDepositDate"
                        (blur)="setPaymentDataValidStatus()"
                       
                        >
                    <mat-datepicker-toggle matSuffix [for]="paymentDepositDate"></mat-datepicker-toggle>
                    <mat-datepicker #paymentDepositDate></mat-datepicker>
                  </mat-form-field>
            </div>
            <div class="col-3">
                <mat-form-field appearance="fill" style="width:100%;font-size:12px;">
                    <mat-label>Comment</mat-label>
                    <input matInput placeholder="Comment" id="pmtComment" (keyup)="setPaymentDataValidStatus()" (focus)="setPaymentDataValidStatus()">
                  </mat-form-field>
            </div>
            <div class="col-1">
                    <button class="btn btn-primary btn-sm mt-3 ace-blue" 
                    style="margin-left:20px;" (click)="addNewPaymentFormPayment()"
                    [disabled]="paymentDataIsInvalid">Submit</button>
            </div>
          
        </div>
    
        <div class="row">
            <div class="col-1">
                
            </div>
            <div class="col-2">
                
            </div>
            <div class="col-1">
                <div *ngIf="paymentValidationMessages.paymentAmountMessage !== ''">
                    <span class="generic-error-presentation">{{paymentValidationMessages.paymentAmountMessage}}</span>
                </div>
            </div>
            <div class="col-1">
                <div >
                    <span *ngIf="paymentValidationMessages.referenceNumberMessage !== ''" class="generic-error-presentation">{{paymentValidationMessages.referenceNumberMessage}}</span>
                    <span *ngIf="paymentValidationMessages.invalidCharactersReferenceNumber != ''" class="generic-error-presentation">{{paymentValidationMessages.invalidCharactersReferenceNumber}}</span><br />
                </div>

            </div>
          
            <div class="col-3">
                <div *ngIf="paymentValidationMessages.dateMessage !== ''">
                    <span class="generic-error-presentation">{{paymentValidationMessages.dateMessage}}</span>
                </div>
            </div>
            <div class="col-3">
                <div *ngIf="paymentValidationMessages.comment !== ''">
                    <span class="generic-error-presentation">{{paymentValidationMessages.comment}}</span>
                </div>
            </div>
    
            <div class="col-1">
                   
            </div>
          
        </div>
    
        <div *ngIf="paymentsBeingAdded" class="spinner-wrapper">
            <mat-spinner></mat-spinner>
        </div>
    
      
      
        <div class="col-12" style="margin-top:20px;">
            <strong style="margin-left:20px;">Existing Payments</strong>
            <br />
            <div *ngIf="invoicePayments.length === 0" style="margin-left: 20px;">
                There are no payments for this invoice.
            </div>
        </div>
        <div *ngIf="invoicePayments.length > 0" class="mat-elevation-z8" style="margin-left:20px;margin-top:20px; margin-right:20px;" >
            <table style="width:98%;">
                <tr>
                    <th style="width:7%;font-size:11px;margin-left:5px;">Date</th>
                    <th style="width:10%;font-size:11px;margin-left:5px;">Type</th>
                    <th  style="width:10%;font-size:11px;">Amount</th>
                    <th style="width:10%;font-size:11px;">Ref No.</th>
                    <th style="width:10%;font-size:11px;">Expected Deposit Date</th>
                    <th  style="width:12%;font-size:11px;">Comment</th>
                    <th  style="width:7%;font-size:11px;">User Name</th>
                    <th  style="width:23%;font-size:11px;"></th>
                </tr>
                <tr *ngFor="let invoicePayment of invoicePayments">
                    <td style="width:7%;font-size:11px;margin-left:10px;">
                        {{invoicePayment.dateGenerated | date:'shortDate'}}
                    </td>
                    <td style="width:10%;font-size:11px;margin-left:10px;">
                        {{invoicePayment.filterDescription}}
                    </td>
                    <td style="width:10%;font-size:11px;">
                        <div *ngIf="+invoicePayment.amount < 0">
                            <span style="color:red">{{invoicePayment.amount | currency}}</span>
                        </div>
                        <div *ngIf="+invoicePayment.amount >= 0">
                            {{invoicePayment.amount | currency}}
                        </div>
                    </td>
                    <td style="width:10%;font-size:11px;">
                        {{invoicePayment.referenceNumber}}
                    </td>
                    <td style="width:10%;font-size:11px;">
                        {{invoicePayment.transactionDate | date:'shortDate'}}
                    </td>
                    <td style="width:12%;font-size:11px;">
                        {{invoicePayment.comments}}
                    </td>
                    <!-- Revised 20240702 b Ken Moss - Added userName to result grid display -->
                    <td style="width:7%;font-size:11px;">
                        {{invoicePayment.userName}}
                    </td>
                    <td style="width:23%;font-size:11px;">
                      
                       
                            <div class="row">
                                <div class="col-3">
                                    <div *ngIf="OnEvalShowDeclineRefundLink(invoicePayment.invoicePaymentID)">
                                      <button type="button" class="btn btn-link" style="font-size:12px;margin-top:-2px;" (click)="OnShowDeclineRefundWorkflow(invoicePayment.invoicePaymentID)" >Decline Refund</button>
                                  </div>
                              </div>
                              <div class="col-1"></div>
                                <div class="col-3">
                                      <div *ngIf="OnEvalShowRefundLink(invoicePayment.invoicePaymentID, +invoicePayment.amount) && this.showWorkingBanner == false">
                                        <button type="button" class="btn btn-link" style="font-size:12px;margin-top:-2px;" (click)="OnShowRefundWorkflow(invoicePayment.invoicePaymentID)" >Refund</button>
                                    </div>
                                </div>
                                <div class="col-1"></div>
                                <div class="col-3">
                                    <div *ngIf="+(invoicePayment.amount) > 0 && GetBalancesForInvoicesWithSameParentPaymentIdForDisplayingAdjustLink(invoicePayment.parentPaymentId) > 0">
                                    <button type="button" class="btn btn-link" style="font-size:12px;margin-top:-2px;" (click)="OnShowAdjustPayment(invoicePayment.invoicePaymentID)" >Adjust</button>
                                </div>
                                </div>
                            </div>
                       
                    </td>
                </tr>
            </table>
        </div>

        <div *ngIf="showDeclineRefundWorkflowForm" style="padding-bottom:30px;margin-left:30px;">
            <div style="margin-top:25px;">
                <strong style="font-size:18px;">Decline Refund</strong>
            </div>
            <div style="width:99%;overflow:hidden">

                <form 
                    (ngSubmit)="OnUpdatePaymentToDeclineStatus()" 
                    novalidate
                    [formGroup]="spaceDeclineRefundForm" >
                    <div class="row" style="margin-top:30px;">
                        <!-- <div class="col-4">
                            <mat-form-field appearance="fill" style="width:100%">
                                <mat-label>Amount</mat-label>
                                <input matInput placeholder="Amount"  formControlName="amount" autocomplete="chrome-off" min=".01" aceCurrencyPositiveNegative>
                                <mat-error>Required, exceeds the valid amount and must be greater than 0</mat-error>
                        </mat-form-field>
                        </div> -->
                        <div class="col-12">
                            <mat-form-field appearance="fill" style="width:100%;font-size:12px;color:red;">
                                <mat-label>Comment</mat-label>
                                <input matInput placeholder="Comment"  formControlName="comment" autocomplete="chrome-off" maxlength="1024">
                                <mat-error>A comment is required</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row" style="margin-top:10px;margin-bottom:20px;">
                        <div class="col-6">
                            <button class="btn btn-light btn-sm" 
                                style="margin-left:20px;margin-right:5px;margin-top:10px"
                                (click)="OnResetDeclineRefundForm()"
                                type="button"
                                >Reset</button> 
                                
                                <button class="btn btn-light btn-sm" 
                                style="margin-left:20px;margin-right:5px;margin-top:10px"
                                (click)="showDeclineRefundWorkflowForm = false"
                                type="button"
                            >Close</button> 
                        

                                <button class="btn btn-primary btn-sm ace-blue"
                                style="margin-left:20px;margin-top:10px" 
                                type="submit"
                                [disabled]="!spaceDeclineRefundForm.valid"
                                >Decline</button> 
                        
                        </div>
                    </div>
                </form>
            </div>
        </div>





        <div *ngIf="showRefundWorkflowForm" style="padding-bottom:30px;margin-left:30px;">
            <div style="margin-top:25px;">
                <strong style="font-size:18px;">spACE Refund</strong>
            </div>
            <div style="width:99%;overflow:hidden">

                <form 
                    (ngSubmit)="onSubmitSpaceRefund()" 
                    novalidate
                    [formGroup]="spaceRefundForm" >
                    <div class="row" style="margin-top:30px;">
                        <div class="col-4">
                            <mat-form-field appearance="fill" style="width:100%">
                                <mat-label>Amount</mat-label>
                                <input matInput placeholder="Amount"  formControlName="amount" autocomplete="chrome-off" min=".01" aceCurrencyPositiveNegative>
                                <mat-error>Required, exceeds the valid amount and must be greater than 0</mat-error>
                        </mat-form-field>
                        </div>
                        <div class="col-8">
                            <mat-form-field appearance="fill" style="width:100%;font-size:12px;color:red;">
                                <mat-label>Comment</mat-label>
                                <input matInput placeholder="Comment"  formControlName="comment" autocomplete="chrome-off" maxlength="1024">
                                <mat-error>A comment is required</mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row" style="margin-top:10px;margin-bottom:20px;">
                        <div class="col-6">
                            <button class="btn btn-light btn-sm" 
                                style="margin-left:20px;margin-right:5px;margin-top:10px"
                                (click)="OnResetSpaceRefundForm()"
                                type="button"
                                >Reset</button> 
                                
                                <button class="btn btn-light btn-sm" 
                                style="margin-left:20px;margin-right:5px;margin-top:10px"
                                (click)="showRefundWorkflowForm = false"
                                type="button"
                            >Close</button> 
                        
                                <button class="btn btn-primary btn-sm ace-blue" 
                                style="margin-left:20px;margin-top:10px" 
                                type="submit"
                                [disabled]="!spaceRefundForm.valid"
                                >Submit</button> 
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <div *ngIf="showPaymentAdjustment" style="padding-bottom:30px;">
            <mat-tab-group class="ml-4 mr-4" style="margin-left:20px;margin-right:20px;margin-top:40px;width:99%">
                @if(displayAdjustTab){
                <mat-tab style="height:1500px;">
                    <ng-template mat-tab-label>
                        <strong>Reverse Payment</strong> 
                    </ng-template>

                    <div style="width:99%;overflow:hidden">

                        <form 
                            (ngSubmit)="OnSubmitPaymentReversal()" 
                            novalidate
                            [formGroup]="paymentReversalForm" >
                            <div class="row" style="margin-top:30px;">
                                <div class="col-2">
                                    <mat-form-field appearance="fill" style="width:100%">
                                        <mat-label>Amount</mat-label>
                                        <input matInput placeholder="Amount"  formControlName="amount" autocomplete="chrome-off" min=".01" aceCurrencyPositiveNegative>
                                        <mat-error>Required, exceeds the valid amount and must be greater than 0</mat-error>
                                </mat-form-field>
                                </div>
                                <div class="col-2" >
                                    @if(paymentReversalIsAdmin){
                                        <mat-form-field appearance="fill" style="width:100%">
                                            <mat-label>Reference Number</mat-label>
                                            <input matInput placeholder="Reference Number"  formControlName="referenceNumber" autocomplete="chrome-off" maxlength="1024"  [readonly]="!paymentReversalIsAdmin">
                                            <mat-error>The Reference Number is required</mat-error>
                                        </mat-form-field>
                                    }
                                    @else
                                    {
                                        <mat-form-field appearance="outline" style="width:100%">
                                            <mat-label>Reference Number</mat-label>
                                            <input matInput placeholder="Reference Number"  formControlName="referenceNumber" autocomplete="chrome-off" maxlength="1024"  [readonly]="!paymentReversalIsAdmin">
                                            <mat-error>The Reference Number is required</mat-error>
                                        </mat-form-field>
                                    }
                                 
                                </div>
                                <div class="col-2" >
                                    @if(paymentReversalIsAdmin){
                                        <mat-form-field  appearance="fill" style="width:100%">
                                            <mat-label>Deposit Date</mat-label>
                                            <input matInput [matDatepicker]="picker" formControlName="depositDate" [readonly]="!paymentReversalIsAdmin">
                                            <mat-hint>MM/DD/YYYY</mat-hint>
                                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                          </mat-form-field>
                                    }
                                    @else
                                    {
                                        <mat-form-field  appearance="outline" style="width:100%">
                                            <mat-label>Deposit Date</mat-label>
                                            <input matInput formControlName="depositDateAsString" [readonly]="!paymentReversalIsAdmin">
                                          </mat-form-field>
                                    }
                                   
                                </div>
                                <div class="col-6">
                                    <mat-form-field appearance="fill" style="width:100%;font-size:12px;color:red;">
                                        <mat-label>Comment</mat-label>
                                        <input matInput placeholder="Comment"  formControlName="comment" autocomplete="chrome-off" maxlength="1024">
                                        <mat-error>A comment is required</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row" style="margin-top:10px;margin-bottom:20px;">
                                <div class="col-6">
                                    <button class="btn btn-light btn-sm" 
                                        style="margin-left:20px;margin-right:5px;margin-top:10px"
                                        (click)="OnResetPaymentReversalForm()"
                                        type="button"
                                        >Reset</button> 
                                        
                                        <button class="btn btn-light btn-sm" 
                                        style="margin-left:20px;margin-right:5px;margin-top:10px"
                                        (click)="OnResetPaymentReversalTransferForm()"
                                        (click)="showPaymentAdjustment = false"
                                        type="button"
                                    >Close</button> 
                                
                                        <button class="btn btn-primary btn-sm ace-blue" 
                                        style="margin-left:20px;margin-top:10px" 
                                        type="submit"
                                        [disabled]="!paymentReversalForm.valid"
                                        >Submit</button> 
                                
                                </div>
                            </div>
                        </form>
                    </div>

                </mat-tab>
                }
                
                
                        <mat-tab  style="height:1500px;">
                            <ng-template mat-tab-label>
                                <strong>Transfer Payment</strong>
                              
                            </ng-template>
                    
                            <ng-container *ngIf="invoiceBalanceList.length == 0">
                                <h4>No invoices with Open balances available</h4>
                            </ng-container>

                            <ng-container *ngIf="invoiceBalanceList.length > 0">

                                <div style="width:99%;overflow:hidden">

                                <form 
                                (ngSubmit)="OnSubmitPaymentReversalAllocateToOtherInvoice()" 
                                novalidate
                                [formGroup]="paymentReversalWithTransferForm" >
                                <div class="row" style="margin-top:30px;">
                                    <div class="col-6">
                                        <mat-form-field appearance="fill" style="width:100%;color:gray">
                                        <mat-label>Select Invoice To Transfer Credit</mat-label>
                                        <mat-select formControlName="invoiceNumber" (selectionChange)="SetPaymentReversalTransferValues();">
                                            <mat-option value="">Select Invoice To Transfer Credit</mat-option>
                                            <mat-option *ngFor="let invoice of invoiceBalanceList" [value]="invoice.invoiceNumber">
                                            {{invoice.invoiceNumber}} - {{invoice.invoiceDate | date:'shortDate'}} - ${{invoice.currentBalance}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error>Selecting an Invoice is required</mat-error>
                                        </mat-form-field>
                                    
                                </div>
                                    <div class="col-6">
                                        <mat-form-field appearance="fill" style="width:100%">
                                            <mat-label>Amount</mat-label>
                                            <input matInput placeholder="Amount"  formControlName="amount" autocomplete="chrome-off" min=".01" aceCurrencyPositiveNegative>
                                            <mat-error>Required, exceeds the valid amount and must be greater than 0</mat-error>
                                    </mat-form-field>
                                    </div>
                                    </div>
                                    <div class="row" style="margin-top:10px;margin-bottom:20px">
                                    <div class="col-6">
                                        <button class="btn btn-light btn-sm" 
                                            style="margin-left:20px;margin-right:5px;margin-top:10px"
                                            (click)="OnResetPaymentReversalTransferForm()"
                                            type="button"
                                            >Reset</button> 
                                       
                                            <button class="btn btn-light btn-sm" 
                                            style="margin-left:20px;margin-right:5px;margin-top:10px"
                                            (click)="OnResetPaymentReversalTransferForm()"
                                            (click)="showPaymentAdjustment = false"
                                            type="button"
                                            >Close</button> 
                                       
                                            <button class="btn btn-primary btn-sm ace-blue" 
                                            style="margin-left:20px;margin-top:10px" 
                                            type="submit"
                                            [disabled]="!paymentReversalWithTransferForm.valid"
                                            >Submit</button> 
                                        </div>
                                       
                                </div>
                            </form>

                            </div>

                        </ng-container>
                    
                    </mat-tab>

                   
                
            </mat-tab-group>
        </div>


    
    </div>
    
    </mat-card>
    
